import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Route } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ResortComponent } from './pages/resort/resort.component';
import { ApartmentsComponent } from './pages/apartments/apartments.component';
import { AmenitiesComponent } from './pages/amenities/amenities.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { ContactComponent } from './pages/contact/contact.component';
import { HomeModule } from './pages/home/home.module';
import { ResortModule } from './pages/resort/resort.module';
import { ApartmentsModule } from './pages/apartments/apartments.module';
import { AmenitiesModule } from './pages/amenities/amenities.module';
import { GalleryModule } from './pages/gallery/gallery.module';
import { ContactModule } from './pages/contact/contact.module';
import { PagesModule } from './pages/pages.module';
import { TavernComponent } from './pages/tavern/tavern.component';
import { ApartmentOneComponent } from './pages/apartment-one/apartment-one.component';
import { ApartmentTwoComponent } from './pages/apartment-two/apartment-two.component';
import { ApartmentThreeComponent } from './pages/apartment-three/apartment-three.component';


const routes: Route[] = [
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'resort',
    component: ResortComponent
  },
  {
    path: 'apartments',
    component: ApartmentsComponent
  },
  {
    path: 'amenities',
    component: AmenitiesComponent
  },
  {
    path: 'tavern',
    component: TavernComponent
  },
  {
    path: 'gallery',
    component: GalleryComponent
  },
  {
    path: 'contact',
    component: ContactComponent
  },
  {
    path: 'apartment1',
    component: ApartmentOneComponent
  },
    {
    path: 'apartment2',
    component: ApartmentTwoComponent
  },
    {
    path: 'apartment3',
    component: ApartmentThreeComponent
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    CommonModule,
    PagesModule,
    RouterModule.forRoot(routes, {useHash: true})
  ],
  declarations: [],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts